export default {
  screens: [
    {
      type: 'intro',
      title: 'J约瑟芬皇后',
      content:
        '约瑟芬皇后，CHAUMET的 “缪斯女神”。自1805年起，约瑟芬皇后便选择CHAUMET作为御用珠宝商，她成为了CHAUMET的重要灵感源泉。',
      idYt: 'gQZPa0SdueQ',
      videoCover: 'world/josephine/video.jpg',
      desktop: {
        cover: 'world/josephine/cover-1.jpg'
      },
      mobile: {
        cover: 'world/josephine/mobile-cover-1.jpg',
        contentStyle: { width: '95%' },
        titleStyle: { width: '60%' },
        coverStyle: {
          width: 'auto',
          width: '50%',
          bottom: '0',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'memento',
      img: 'world/josephine/memento.jpg',
      content:
        '约瑟芬皇后出生于植物丰茂的马提尼克，终其一生都对洋溢异国风情、色彩鲜艳的风格情有独钟。<br/><br/> 她在艺术、时尚、装饰和植物等方面天生品味非凡，成为了那个时代的标杆。',
      cover: 'world/josephine/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/cover-3.jpg'
      },
      mobile: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/mobile-cover-3.jpg',
        coverStyle: {
          width: '62%',
          top: '41%',
          left: '-19%',
          right: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '约瑟芬皇后作为“缪斯女神”一直滋养着CHAUMET的设计，品牌诞生230年之际，推出Joséphine加冕·爱系列，致敬灵感缪斯约瑟芬皇后，延续了拿破仑和约瑟芬皇后的传奇爱情，将冠冕幻化为戒指、手镯、项链、耳环，诠释“为爱加冕，冠你一生”的完美誓言。'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/josephine.js